export default "/_next/static/chunks/fonts/Montserrat-BoldItalic-latin-4a30514717d24ecf4fb3685d51a82e55.woff2";